import React, { useEffect } from "react";
import { Plus, Calendar } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../hooks/useRedux";
import {
  fetchEventConfigs,
  toggleChannel,
  toggleEventConfigChannel,
} from "../../store/features/eventConfig/eventConfigActions";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../store/features/ui/uiActions";

export function EventConfigPage() {
  const dispatch = useAppDispatch();
  const { configs, isLoading, error } = useAppSelector(
    (state) => state.eventConfig
  );
  console.log("configs", configs);
  useEffect(() => {
    dispatch(fetchEventConfigs());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      dispatch(showErrorNotification(error.message));
    }
  }, [error, dispatch]);

  const handleToggleChannel = async (configId, channel, mediaId, enabled) => {
    try {
      dispatch(toggleEventConfigChannel(configId, channel, mediaId, enabled));
    } catch (error) {
      console.error(error);
    }
  };

  const Switch = ({ enabled, onChange, disabled = false }) => (
    <label className="custom-switch">
      <input
        type="checkbox"
        checked={enabled}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="switch-slider"></span>
    </label>
  );

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "400px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className=" container-fluid">
      {/* Header */}
      <div className=" mb-4">
        <div
          className="card-body"
          style={{ backgroundColor: "white", borderRadius: "5px" }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="card-title fw-semibold mb-1">
                Event Configuration Matrix
              </h5>
              <p className="text-muted mb-0">
                Configure which channels are enabled for each event type
              </p>
            </div>
            {/* <button className="btn btn-primary d-flex align-items-center gap-2">
              <Plus size={16} />
              Add Event Type
            </button> */}
          </div>
        </div>
      </div>

      {/* Configuration Table */}
      <div className="card">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th className="fw-semibold">Event Type</th>
                <th className="text-center fw-semibold">SMS</th>
                <th className="text-center fw-semibold">Email</th>
                <th className="text-center fw-semibold">WhatsApp</th>
                <th className="text-center fw-semibold">Telegram</th>
                <th className="text-center fw-semibold">Last Edited</th>
              </tr>
            </thead>
            <tbody>
              {configs.map((config) => (
                <tr key={config.id}>
                  <td>
                    <div>
                      <div className="fw-medium text-dark">
                        {config.eventType.replace(/_/g, " ")}
                      </div>
                      <small className="text-muted">{config.eventType}</small>
                    </div>
                  </td>
                  <td className="text-center">
                    <Switch
                      enabled={config.sms.enabled}
                      onChange={() =>
                        handleToggleChannel(
                          config.id,
                          "sms",
                          config.sms.id,
                          config.sms.enabled
                        )
                      }
                    />
                  </td>
                  <td className="text-center">
                    <Switch
                      enabled={config.email.enabled}
                      onChange={() =>
                        handleToggleChannel(
                          config.id,
                          "email",
                          config.email.id,
                          config.email.enabled
                        )
                      }
                    />
                  </td>
                  <td className="text-center">
                    <Switch
                      enabled={config.whatsapp.enabled}
                      onChange={() =>
                        handleToggleChannel(
                          config.id,
                          "whatsapp",
                          config.whatsapp.id,
                          config.whatsapp.enabled
                        )
                      }
                    />
                  </td>
                  <td className="text-center">
                    <Switch
                      enabled={config.telegram.enabled}
                      onChange={() =>
                        handleToggleChannel(
                          config.id,
                          "telegram",
                          config.telegram.id,
                          config.telegram.enabled
                        )
                      }
                    />
                  </td>
                  <td className="text-center">
                    <div className="d-flex align-items-center justify-content-center text-muted small">
                      <Calendar size={14} className="me-1" />
                      {new Date(config.updatedAt).toLocaleDateString()}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="row g-3 mt-4">
        <div className="col-md-3">
          <div
            className="card  bg-opacity-10 border-primary border-opacity-25"
            style={{ backgroundColor: "#fcedcf" }}
          >
            <div className="card-body text-center">
              <div className="display-6 fw-bold text-primary">
                {configs.filter((c) => c.sms.enabled).length}
              </div>
              <div className="small text-primary">SMS Enabled</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card bg-success bg-opacity-10 border-success border-opacity-25">
            <div className="card-body text-center">
              <div className="display-6 fw-bold text-success">
                {configs.filter((c) => c.email.enabled).length}
              </div>
              <div className="small text-success">Email Enabled</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card bg-info bg-opacity-10 border-info border-opacity-25">
            <div className="card-body text-center">
              <div className="display-6 fw-bold text-info">
                {configs.filter((c) => c.whatsapp.enabled).length}
              </div>
              <div className="small text-info">WhatsApp Enabled</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card bg-warning bg-opacity-10 border-warning border-opacity-25">
            <div className="card-body text-center">
              <div className="display-6 fw-bold text-warning">
                {configs.filter((c) => c.telegram.enabled).length}
              </div>
              <div className="small text-warning">Telegram Enabled</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
